 

  
export const licenseKey = 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjUxMzRkNGM1LWViZGYtNDg3Zi04ZGVkLTgxMTQyY2FhYWMwNyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.ZFsjRagJw1jOey1cfrUXbhFrjd0ebKBCepwAAK82fUvxCUqu6/URTe+xpZDBwczay3+4A8upKrGb1FOu5wBNHdpSFUFxlQ6uVr8fGn6BnkF42ULZJysSCPmzj9yH416xd3rvwg==';
 